import { EChartsOption, LineSeriesOption } from "echarts";
import { SignalTransform } from ".";
import { generateNumbers } from "@/utils/math";
import Decimal from "decimal.js";
export type PlayStatus = "play" | "pause" | "stop";
export const LENGTH = 10; // S
export const decreasingSequence = generateNumbers(LENGTH);
export const preDecreasingSequence = generateNumbers(0.25); // 250 ms

export const btnToggleOptions = [
  { label: "大", value: 1, interval: 0 },
  { label: "中", value: 2, interval: 10 },
  { label: "小", value: 3, interval: 20 },
];
export const getDefaultSeriesData = () => {
  const res = {
    UIRx_ABSSplitCtrlSts_BCh1: [],
    UIRx_BrakeAirGap: [],
    UIRx_BrkPdlPositionAct: [],
    UIRx_DrvrReqTrgtFxBrk_Bch1: [],
    UIRx_FLWhlSpd_BCh1: [],
    UIRx_FRWhlSpd_BCh1: [],
    UIRx_RLWhlSpd_BCh1: [],
    UIRx_RRWhlSpd_BCh1: [],
    UIRx_TTL: [],
    UIRx_VehSpd: [],
    UIRx_WhlBrkTqAct_FL_BCh1: [],
    UIRx_WhlBrkTqAct_FR_BCh1: [],
    UIRx_WhlBrkTqAct_RL_BCh1: [],
    UIRx_WhlBrkTqAct_RR_BCh1: [],
  } as DomianControl.ADASeriesData;
  return res;
};

export function parseUIRx_BrakeAirGap(data: number) {
  // let value = Math.abs(data);
  return data;
}
export function limitUIRx_BrakeAirGap(data: number) {
  // BrakeAirGap  0对应最小的间隙，0.5对应最大间隙  小于 0 取 0  大于 0.5 取0.5
  // let value = Math.min(Math.max(data, 0), 0.5);
  // BrakeAirGap >0 取0  < -0.5 取0.5
  let value = data;
  if (data > 0) value = 0;
  if (data < -0.5) value = -0.5;
  value = Math.abs(value);
  return value;
}
export function parseUIRx_DrvrReqTrgtFxBrk_Bch1(data: number) {
  data = Math.abs(data);
  // 换算公式：绘图使用值=DrvrReqTrgtFxBrk×0.374
  const num = new Decimal(data);
  const value = Math.floor(num.times(0.374).toNumber());
  return value;
}
export function parseUIRx_BrkPdlPositionAct(data: number) {
  const value = data > 4.5 ? 3000 : 0; // 检测到踏板开度数值大于4.5%时（即识别踏板开度小于4.5%到大于4.5%的上升沿
  return value;
}
export function parseUIRx_WhlBrkTqAct_FL_BCh1(data: number) {
  let value = Math.abs(data); // 超过-3000的值按-3000进行显示。需符号取反或取绝对值
  value = value > 3000 ? 3000 : value;
  return value;
}

export const optionseries1 = () => [
  {
    id: "UIRx_DrvrReqTrgtFxBrk_Bch1",
    name: "驾驶员目标制动力",
    color: "#c10301",
    markLine: {
      symbol: "none",
      lineStyle: {
        type: "dashed",
        color: "#fff",
      },
      label: {
        show: false,
      },
      data: [
        {
          name: "UIRx_DrvrReqTrgtFxBrk_Bch1", // UIRx_DrvrReqTrgtFxBrk_Bch1 驾驶员目标制动力DrvrReqTrgtFxBrk（单位换算后的值）大于50Nm处画一条虚线
          xAxis: -1, // "0.5" 字符串：x轴的值  数字： x轴坐标 （下标 index）
        },
        {
          name: "UIRx_WhlBrkTqAct_FL_BCh1", // UIRx_WhlBrkTqAct_FL_BCh1 FL的实际制动扭矩达到2600Nm处画一条虚线
          xAxis: -1, // 默认不展示
        },
      ],
    },
  },
  {
    id: "UIRx_FLWhlSpd_BCh1",
    name: "左前实际制动力",
    color: "#2E8B57",
  },
  {
    id: "UIRx_FRWhlSpd_BCh1",
    name: "右前实际制动力",
    color: "#ffc101",
  },
  {
    id: "UIRx_RLWhlSpd_BCh1",
    name: "左后实际制动力",
    color: "#0372bf",
  },
  {
    id: "UIRx_RRWhlSpd_BCh1",
    name: "右后实际制动力",
    color: "#9B30FF",
  },
];

export const optionseries2 = () => [
  {
    id: "UIRx_VehSpd",
    name: "车速",
    color: "#c10301",
  },
  {
    id: "UIRx_WhlBrkTqAct_FL_BCh1",
    name: "左前轮轮速",
    color: "#2E8B57",
  },
  {
    id: "UIRx_WhlBrkTqAct_FR_BCh1",
    name: "右前轮轮速",
    color: "#ffc101",
  },
  {
    id: "UIRx_WhlBrkTqAct_RL_BCh1",
    name: "左后轮轮速",
    color: "#0372bf",
  },
  {
    id: "UIRx_WhlBrkTqAct_RR_BCh1",
    name: "右后轮轮速",
    color: "#9B30FF",
  },
];
// export const optionseries1 = () => [
//   {
//     id: "big",
//     name: "大间隙",
//     color: "#2E8B57",
//   },
//   {
//     id: "middle",
//     name: "中间隙",
//     color: "#ffc101",
//   },
//   {
//     id: "small",
//     name: "小间隙",
//     color: "#c10301",
//   },
// ];
// export const optionseries2 = () => [
//   {
//     id: "UIRx_ACUYawRate",
//     name: "实际横摆特性",
//     color: "#0372bf",
//   },
//   {
//     id: "UIRx_OrgYawRate",
//     name: "原始横摆特性",
//     color: "#9B30FF",
//   },
// ];
// export const optionseries3 = () => [
//   {
//     id: "UIRx_AxleStAng_RA",
//     name: "后轮角度",
//     color: "#2E8B57",
//   },
// ];

export const getTooltip = () => {
  return {
    show: true,
    // formatter: `{c}`,
    formatter: function (params: any[]) {
      console.log("[BOWEN_LOG] 🚀 ~~ getTooltip ~~ params:", params);

      const axisValue = params[0]?.axisValue || "";
      let tooltipHtml = `<div>${axisValue}</div>`;
      const uniqueParams = new Map<string, any>();

      params.forEach((param) => {
        if (param.value === undefined) return;

        // 生成一个唯一的键，结合 axisValue 和 data
        const key = `${param.axisValue}-${JSON.stringify(param.value)}`;

        // 如果已经存在相同的键，则跳过
        if (!uniqueParams.has(key)) {
          uniqueParams.set(key, param);
        }
      });

      uniqueParams.forEach((param) => {
        if (param.seriesType === "line") {
          tooltipHtml += `<div style="display: flex; align-items: center;">
                        <span style="display: inline-block; margin-right: 5px; border-radius: 50%; width: 10px; height: 10px; background-color: ${param.color};"></span>
                        <span> ${param.seriesName}</span>: <span> ${param.value}</span>
                      </div>`;
        }
      });

      return tooltipHtml;
    },
  };
};

export const getGrid = () => ({
  top: 30,
  left: 50,
  right: 50,
  bottom: 55,
});
export const getTitle = () =>
  ({
    top: 0,
    left: 5,
    textStyle: {
      color: "#032f2b",
      fontSize: 12,
    },
  } as EChartsOption["title"]);

export const getXaxis = () => {
  const lineColor = "rgba(199, 237, 250,0.2)";

  return {
    name: "踏板开度(%)",
    type: "value",
    max: 100,
    min: 0,
    nameTextStyle: {
      color: "#fff",
    },
    interval: 25,
    // nameGap: -30,
    // minorTick: {
    //   show: true,
    // },
    // minorSplitLine: {
    //   show: true,
    //   lineStyle: {
    //     color: lineColor,
    //   },
    // },
    axisPointer: {
      snap: true,
      lineStyle: {
        color: "#8e96a1",
        width: 2,
      },
      label: {
        show: false,
        // formatter: function (params) {
        //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
        // },
        backgroundColor: "#3fafa5",
      },
      handle: {
        show: true,
        color: "#3fafa5",
        size: 30,
        margin: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
      },
    },
    splitLine: {
      show: true,
      // interval:25,
      // interval: (index: number, value: string) => {
      //   return (
      //     (Number(value) % 1 === 0 || Number(value) === 1) &&
      //     Number(value) !== 15
      //   );
      // },
      lineStyle: {
        color: lineColor,
      },
    },
    axisLabel: {
      show: true, // 隐藏 x 轴标签
      // interval:25,
      // interval: interval,
      // formatter: (number: string) => {
      //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
      //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
      // },
    },
    // axisTick: {
    //   interval,
    // },
    axisLine: {
      onZero: false,
      lineStyle: {
        color: lineColor,
      },
    },
  };
};
const dataZoomOption: any = {
  // rangeMode: "percent",
  // backgroundColor: "#8e96a1",
  fillerColor: "#8e96a1",
  borderRadius: 5,
  moveHandleSize: 10,
  moveHandleStyle: {
    color: "#8e96a1",
  },
  brushStyle: {
    color: "#5aac5d",
    opacity: 0.7,
    borderWidth: 2,
    borderColor: "#5aac5d",
  },
  handleIcon:
    "path://M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2zm0 20C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z", // jshint ignore:line
  handleSize: 35,
  handleStyle: {
    color: "rgba(0,0,0,1)",
    borderColor: "#8e96a1",
    borderWidth: 0,
    backgroundColor: "#8e96a1",
    opacity: 0.7,
  },
  backgroundColor: "rgba(0,0,0,0.0)",
};
export const getDataZoom = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      startValue: 0,
      endValue: 8000,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      top: 60,
      bottom: 40,
    },
  ];
  return dataZoom;
};
export const getDataZoom2 = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      show: false,
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      startValue: 0,
      endValue: 50,
      top: 60,
      bottom: 40,
    },
  ];
  return dataZoom;
};
